import { render, staticRenderFns } from "./CalendarIcon.vue?vue&type=template&id=a60fda50&scoped=true"
import script from "./CalendarIcon.vue?vue&type=script&lang=js"
export * from "./CalendarIcon.vue?vue&type=script&lang=js"
import style0 from "./CalendarIcon.vue?vue&type=style&index=0&id=a60fda50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60fda50",
  null
  
)

export default component.exports